<template>
  <div id="myDateShow">
    <div class="title">{{swiperId?"修改":"新增"}} 农基商资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">轮播类型</div>
        <div class="value">
          {{swiper.swiperType=='0'?'商品轮播':'活动轮播'}}
        </div>
      </div>
      <div class="line">
        <div class="key">活动轮播跳转路径</div>
        <div class="value">
          <el-input class="w500" v-model="swiper.url" placeholder="请填写跳转路径"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">轮播图片</div>
        <div class="value">
          <div class="value">
            <img class="skuImg" v-if="swiper.imgUrl" :src="swiper.imgUrl" alt="">
            <div class="upload">
              <el-upload
                      :headers="headers"
                      ref="defaultUpload"
                      :on-progress="progress"
                      :on-change="defaultUpload"
                      :on-success="defaultSuccess"
                      class="upload-demo"
                      name="multipartFile"
                      :action="baseURL+'/swiper/uploadDefaultImg'"
                      :auto-upload="false"
                      :show-file-list="false"
                      list-type="picture-card">
                <i class="el-icon-plus"></i>
                <div class="el-upload__tip" slot="tip">上传新的主图，图片长宽为375:150，文件格式为通用jpg/png，数量：1</div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getSwiperById, newVue, addSwiperByActive} from "../../network/swiper";

  export default {
    name: "SwiperInsert",
    data(){
      return{
        swiper: {},
        swiperId: '',
        authorization:"",
        headers: {},
        baseURL:newVue.baseURL
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/swiper/list";
      this.common.HeaderLocationTwo.name = "轮播资料管理"
      this.common.HeaderLocationThree.name = "新增or修改活动轮播列表"
      this.authorization=newVue.obj.common.loginInfo.jwtToken;
      this.headers.Authorization = this.authorization;
      if (this.$route.params.id!=null){
        this.swiperId = this.$route.params.id;

        getSwiperById(this.swiperId).then(res => {
          this.swiper = res.data;
        })
      }


    },
    methods: {
      defaultSuccess(response, file, fileList){
        this.loading.close()
        this.swiper.imgUrl = response.data
      },
      defaultUpload(file, fileList) {
        if (file.name.indexOf("png") || file.name.indexOf("jp")) {
          this.$refs.defaultUpload.submit()
        } else {
          this.$message({
            showClose: true,
            message: '请上传jpg或png等图片',
            type: 'error'
          })
        }
      },
      upLoadSeccess(res){
        this.swiper.agreementUrl = res.data;
      },
      backClick(){
        this.$router.push("../list");
      },
      addClick(){
        getOneLeave().then(res => {
          for (let i = 0;i<res.data.length;i++){
            let cityItem = new City(res.data[i]);
            this.cityArr.push(cityItem)
          }
          this.cityArr.splice(0,1)
        })
      },
      upLoad (file, fileList) {
        this.swiper.agreementName = file.name.split(".")[0]
        this.$refs.upload.submit()
      },
      submit(){
        addSwiperByActive(this.swiper).then(res => {
          console.log(res);
        })
      },
      progress(){
        this.loading = this.$loading({
          lock: true,
          text: '正在上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
